import React from 'react';
import PropTypes from 'prop-types';

export function InstructionBlock(props) {
  return <div  tabindex="0" className={props.className}>{props.children}</div>;
}

InstructionBlock.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * child components inside wrapper
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

InstructionBlock.defaultProps = {
  className: '',
};
